import * as React from 'react';
import classNames from 'classnames';
import Footer from 'components/footers/Footer';
import NavbarDual from 'components/navbars/navbar-dual/NavbarDual';
import NavbarTopHorizontal from 'components/navbars/navbar-horizontal/NavbarTopHorizontal';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import NavbarVertical from 'components/navbars/navbar-vertical/NavbarVertical';
import { useAppContext } from 'providers/AppProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { Container } from 'react-bootstrap';
import { Outlet, useNavigate } from 'react-router-dom';
import { Dropdown, Row } from 'react-bootstrap';
import useBranchList from 'pages/apps/hooks/useGetBranchList';
import { useBranchContext, Branch } from 'providers/BranchProvider';
import { ensurePushSubscription } from 'utils/webPush';

const MainLayout = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();
  const { contentClass, footerClass } = useMainLayoutContext();
  const { branches, selectedBranch, setSelectedBranch } = useBranchContext();
  const data = useBranchList();
  const navigate = useNavigate();

  const handleSelectBranch = (branch: Branch | null) => {
    if (branch) {
      localStorage.setItem('selectedBranch', JSON.stringify(branch));
      navigate(`/product/${branch.branchDomain}`);
    }
    setSelectedBranch(branch);
  };

  const dropdownContent = (
    <Dropdown style={{ width: 'auto', minWidth: '10rem' }}>
      <Dropdown.Toggle variant="phoenix-primary" style={{ width: '100%' }}>
        {selectedBranch?.branchName}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ width: '100%' }}>
        {data.map(branch => (
          <Dropdown.Item
            key={branch.branchId}
            onClick={() => handleSelectBranch(branch)}
          >
            {branch?.branchName}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );

  React.useEffect(() => {
    const storedBranch = localStorage.getItem('selectedBranch');

    if (storedBranch) {
      setSelectedBranch(JSON.parse(storedBranch));
    } else if (data.length > 0) {
      const defaultBranch = data[0];
      setSelectedBranch(defaultBranch);
      localStorage.setItem('selectedBranch', JSON.stringify(defaultBranch));
    }
  }, [data, setSelectedBranch]);

  React.useEffect(() => {
    void ensurePushSubscription();
  }, []);

  return (
    <Container fluid className="px-0">
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <>
          {selectedBranch && <NavbarVertical branchDomain={selectedBranch} />}
        </>
      )}
      {navbarPosition === 'vertical' && branches && (
        <NavbarTopDefault>
          <Row className="gap-4" style={{ flexWrap: 'nowrap' }}>
            {dropdownContent}
          </Row>
        </NavbarTopDefault>
      )}
      {(navbarPosition === 'horizontal' || navbarPosition === 'combo') && (
        <NavbarTopHorizontal />
      )}
      {navbarPosition === 'dual' && <NavbarDual />}

      <div className={classNames(contentClass, 'content')}>
        <Outlet />
        <Footer className={classNames(footerClass, 'position-absolute')} />
      </div>
    </Container>
  );
};

export default MainLayout;
